module.exports = __webpack_public_path__ + "static/media/Lauren Wolfe Headshot.3d1e91e9.jpeg";